module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/banana-7482a0b0.webp";